import React, {Component} from "react";
import { connect } from 'react-redux';
import GoogleLoginButton from 'react-google-login';
import * as actions from '../../redux/auth/actions';

export class GoogleLogin extends Component {
  googleLoginResponse = (response) => {
    if (response){
      let g = response.profileObj;
      let token = response.tokenId;
      this.props.verifyGoogleLogin(g,token,g.email)
    }
  }

  componentDidUpdate(){
    const { auth,history } = this.props
    if (auth.user && auth.jwtToken){
      history.push('/')
    }
  }
  
  render() {
    const { auth } = this.props
    
    return (
      <div className='container text-center'>
         <div className='row'>
              <br /><br />
         </div>
         <div className='row'>
              <br /><br />
         </div>
         <div className='row'>
            <div className='col-sm loginLogo'>
              <img src='/img/swarm-colony-logo-v2.png'  />
            </div>
         </div>
         {auth.error?(
          <div className='row'>
              <div className='col-sm'>
                  <div className="alert alert-danger" role="alert">
                      <strong>ERROR!</strong> {auth.error}
                  </div>
              </div>
          </div> 
          ):null}
          <div className='row'>
              <br />
          </div>
          <div className='row'>
            <div className='col-sm'>
              <button className="twofaLoginButton" type="button" onClick={()=>twofaLoginWithEmailOnClick(this.props)} >
                  2FA Login With Email
              </button>
              &nbsp;&nbsp;
              <GoogleLoginButton
                clientId="454565003270-6ildibm47krjtp7414fkrg3hlhhplr6u.apps.googleusercontent.com"
                buttonText="Login with Google"
                onSuccess={this.googleLoginResponse.bind(this)}
                onFailure={this.googleLoginResponse.bind(this)}
              />
            </div>
          </div>
          <div className='row'>
              <br />
          </div> 
      </div>
    );
  }
}

const twofaLoginWithEmailOnClick=props=>{
  const { history } = props
  history.push('/loginWithTAC')
}

const mapStateToProps = (state, ownProps) => {
  return {
     auth: state.auth
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
      verifyGoogleLogin: (googleProfile,googleToken,email) => {
          dispatch(actions.verifyGoogleLogin(googleProfile,googleToken,email))
      }
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(GoogleLogin);


// WEBPACK FOOTER //
// ./src/views/Login/GoogleLogin.js